export { AutoForwardPlugin } from "./auto-forward";